import React, { useState, useEffect } from "react";
import { array, func, number, object } from "prop-types";

import Carousel from "../../../atoms/carousel";
import RightArrow from "../../../atoms/icons/right-arrow";
import LeftArrow from "../../../atoms/icons/left-arrow";
import LineRightArrow from "../../../atoms/icons/line-right-arrow";
import LineLefttArrow from "../../../atoms/icons/line-left-arrow";
import CrossIcon from "../../../atoms/icons/cross-icon";
import { WithLazy } from "@quintype/components";

import removeHTMLTags from "../../../helper/removeHTMLTags";

import "./photo-slider.m.css";

const FullScreenView = ({ elements = [], closeFullScreen }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const handleKeyUp = (e) => {
    if (e.keyCode === 27) {
      e.preventDefault();
      closeFullScreen();
    }
  };

  const setIndex = (index) => {
    setSelectedIndex(index);
  };

  useEffect(() => {
    window.addEventListener("keyup", handleKeyUp, false);
    if (document) document.body.style.overflowY = "hidden";

    return () => {
      window.removeEventListener("keyup", handleKeyUp, false);
      if (document) document.body.style.overflowY = "auto";
    };
  }, []);

  return (
    <div styleName="modal-overlay">
      <div onClick={closeFullScreen} styleName="close">
        <CrossIcon />
      </div>
      <div styleName="modal">
        <div>
          <div styleName="mobile-swipe">
            <LineLefttArrow />
            Swipe Left Or Right
            <LineRightArrow />
          </div>
          <Carousel
            carouselName={`photo-slider-${Math.ceil(Math.random() * 1000)}`}
            options={{
              type: "carousel",
              perView: 1,
              perTouch: 1,
            }}
            totalItems={elements.length}
            leftArrow={<LeftArrow />}
            rightArrow={<RightArrow />}
            currentIndex={selectedIndex}
            setCurrentIndex={setIndex}
          >
            {sliderItemsView(elements)}
          </Carousel>
          <div styleName="body-content">
            <ImageCaptions elements={elements} index={selectedIndex} />
          </div>
        </div>
      </div>
    </div>
  );
};

FullScreenView.propTypes = {
  elements: array,
  closeFullScreen: func,
  story: object,
};

const sliderItemsView = (images) =>
  images.map((element, index) => (
    <WithLazy margin="300px" key={index}>
      {() => (
        <div styleName="item-wrapper" key={index}>
          <img src={`https://images.thequint.com/${element["image-s3-key"]}`} />
        </div>
      )}
    </WithLazy>
  ));

const ImageCaptions = ({ elements, index }) => {
  const element = elements[index];
  return (
    <div styleName="image-captions">
      <div styleName="elements-count">{`${index + 1}/${elements.length}`}</div>
      <h2 styleName="title">{removeHTMLTags(element.title)}</h2>
      <p styleName="attribution">{removeHTMLTags(element["image-attribution"])}</p>
    </div>
  );
};

ImageCaptions.propTypes = {
  elements: array,
  index: number,
};

const PhotoStorySlider = ({ images, story }) => {
  const noOfItems = images.length;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [fullScreen, setFullScreen] = useState(false);

  const goToSlide = (index) => () => setSelectedIndex(index);

  const renderBottomControls = (items) => {
    return (
      <div styleName="controls">
        {items.map((child, index) => (
          <div
            key={index}
            styleName={selectedIndex === index ? "bullet active" : "bullet"}
            onClick={goToSlide(index)}
          />
        ))}
      </div>
    );
  };

  const setFullScreenView = () => setFullScreen(!fullScreen);

  return (
    <div styleName="photo-slider-wrapper">
      <div styleName="photo-slider">
        <Carousel
          carouselName="photo-slider-full-screen"
          options={{
            type: "carousel",
            perView: 1,
            perTouch: 1,
          }}
          totalItems={images.length}
          showArrows={false}
          showBullets={false}
          currentIndex={selectedIndex}
        >
          {sliderItemsView(images)}
        </Carousel>

        <div styleName="bottom-controls">
          <button disabled={selectedIndex === 0} onClick={goToSlide(selectedIndex - 1)}>
            <LeftArrow />
          </button>
          <div styleName="indicators">
            {images.length > 1 && renderBottomControls(images)}
            <div styleName="view-full-screen" onClick={setFullScreenView}>
              <span styleName="text">View Fullscreen</span>
              <LineRightArrow />
            </div>
          </div>
          <button disabled={selectedIndex >= noOfItems - 1} onClick={goToSlide(selectedIndex + 1)}>
            <RightArrow />
          </button>
        </div>
      </div>
      {fullScreen && <FullScreenView elements={images} closeFullScreen={setFullScreenView} story={story} />}
      <ImageCaptions elements={images} index={selectedIndex} />
    </div>
  );
};

PhotoStorySlider.propTypes = {
  images: array,
  story: object,
};

export default PhotoStorySlider;
